import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { useFeature } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { FlexGap, Pill } from '@treams/treams-ui';

import { StyrBadge } from '../../../connectors/products/StyrBadge';
import { useJobTitleName } from '../../../job/useJobTitleName';
import SettingsCollection, { ArchiveRestoreMutationTuple } from '../../generic/SettingsCollection';

export default function JobTitlesListContainer() {
	const history = useHistory();
	const jobTitleName = useJobTitleName();
	const { t } = useTranslation();
	const hasGrowthPath = useFeature(graphql.FeatureName.GrowPath);

	return (
		<SettingsCollection
			query={graphql.useJobTitlesQuery}
			lazyQuery={graphql.useJobTitlesLazyQuery}
			field="jobTitles"
			translationKey="settings.jobTitles"
			title={(title: graphql.JobTitle) => jobTitleName(title)}
			link={(title) => `/settings/jobs/titles/${title.id}`}
			titleBadge={(jobTitle: graphql.JobTitle) => {
				const excluded = hasGrowthPath && jobTitle.excludedFromGrowthPath;

				if (!jobTitle.styrData?.jobID && !excluded) {
					return null;
				}

				return (
					<FlexGap alignItems="center" gap={1}>
						{excluded && <Pill small>{t('jobTitle.growthPathExclusion.marker')}</Pill>}
						{jobTitle.styrData?.jobID && (
							<StyrBadge
								tooltip={
									jobTitle.styrData.jobName
										? t('settings.connectors.styr.badge.linkedTo', {
												name: jobTitle.styrData.jobName,
											})
										: undefined
								}
							/>
						)}
					</FlexGap>
				);
			}}
			variables={{}}
			archive={graphql.useArchiveJobTitleMutation() as unknown as ArchiveRestoreMutationTuple}
			restore={graphql.useRestoreJobTitleMutation() as unknown as ArchiveRestoreMutationTuple}
			onAdd={() => history.push('/settings/jobs/titles/new')}
		/>
	);
}
